import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

import type { AuthenticationMethod } from '@izimi/components';
import {
  AuthenticationMethodSelectorButton,
  AuthenticationMethodSelectorModal,
  useTracking,
} from '@izimi/components';
import { TrackingEventCategory } from '@izimi/modules';
import { useGetNabanAuthenticationModes } from 'core/modules/naban';
import { fetchService } from 'core/services/fetchService';
import { Routes } from 'navigation/types';
import { mapAuthenticationMethodToTrackingAction } from 'util/tracking';

export const HeaderMethodSelectorButton = () => {
  const [showModal, setShowModal] = useState(false);
  const { trackEvent } = useTracking();
  const { hasOnlyCitizenModeToken } = useGetNabanAuthenticationModes();
  const navigate = useNavigate();

  const handleAuthenticationMethodSelectorClick = () => {
    setShowModal((prev) => !prev);
  };

  const onClose = () => setShowModal(false);
  const onItemSelection = (item: AuthenticationMethod) => {
    trackEvent({
      category: TrackingEventCategory.General,
      action: mapAuthenticationMethodToTrackingAction({ type: item.type }),
    });
    if (window.location.pathname !== Routes.Overview) {
      navigate(Routes.Overview);
    }
    onClose();
  };

  return (
    <>
      {!hasOnlyCitizenModeToken && (
        <AuthenticationMethodSelectorButton onClick={handleAuthenticationMethodSelectorClick} />
      )}
      {showModal && (
        <AuthenticationMethodSelectorModal
          fetchService={fetchService}
          onClose={onClose}
          onItemSelection={onItemSelection}
        />
      )}
    </>
  );
};
